import BaseModel from "./base/baseModel";

export default class OrigemAtendimentoModel extends BaseModel {
    id?: number = null;
    franquiaId?: number = null;
    descricao: string = null;
}
